import {
  ControlProps,
  RankedTester,
  rankWith,
  scopeEndsWith,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  NotesContainerStyle,
  NotesContent,
  NotesTitle,
} from "../../messageType/contentType/FormContent.style";

const NotesViewRenderer = ({ data, label }: ControlProps) => {
  return (
    <>
      {data && (
        <NotesContainerStyle>
          <NotesTitle>{label} :</NotesTitle>
          <NotesContent data-testid="form-notes">{data}</NotesContent>
        </NotesContainerStyle>
      )}
    </>
  );
};

export const notesViewTester: RankedTester = rankWith(
  7, //increase rank as needed
  scopeEndsWith("notes"),
);

export const isOverrideViewTester: RankedTester = rankWith(
  3, //increase rank as needed
  scopeEndsWith("isOverride"),
);

export default withJsonFormsControlProps(NotesViewRenderer);
